/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  setSelectedDeviceAction,
  setDeviceDataCountAction,
  setDrawerCountsAction,
  setSelectedDeviceAlarmsAction,
  setNoOfSelectedRowAction,
  setDeviceActionAction,
  selectedTempalateAction,
  setSelectedTypeAction,
  selectedGlobalTempalateAction,
  setSelectedDeviceAlarmCountAction,
  setOpenDeviceDrawerAction,
  setSelecteRnCellConfigAction,
  setRadioFirstLteCellAction,
  setRadioSecondLteCellAction,
  setSelectedRadioAction,
  setOpenRnDrawerAction,
  setSelectedDuAction,
  setRadioFirstNrCellAction,
  setRadioSecondNrCellAction,
  setOpenDuDrawerAction,
  setOpenRnCUDrawerAction,
  setOpenLteDrawerAction,
  setOpenNrDrawerAction,
  setOpenCellDrawerAction,
  setSiteOfflineAction,
  setCellSavedAction,
  setSelectedNoteAction,
  setLabelListAction,
  setNotifyLabelAction,
  setSelectedDeviceIdAction,
  setSelectedGeoRegionsAction,
} from "./actions";
import { initialState } from "./initialState";

const helpersSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setSelectedDevice: setSelectedDeviceAction,
    setDeviceDataCount: setDeviceDataCountAction,
    setDrawerCounts: setDrawerCountsAction,
    setSelectedDeviceAlarms: setSelectedDeviceAlarmsAction,
    setSelectedDeviceAlarmCount: setSelectedDeviceAlarmCountAction,
    setNoOfSelectedRow: setNoOfSelectedRowAction,
    setDeviceAction: setDeviceActionAction,
    selectedTemplate: selectedTempalateAction,
    setSelectedType: setSelectedTypeAction,
    selectedGlobalTemplate: selectedGlobalTempalateAction,
    setOpenDeviceDrawer: setOpenDeviceDrawerAction,
    setSelectedRnCellConfig: setSelecteRnCellConfigAction,
    setRadioFirstLteCell: setRadioFirstLteCellAction,
    setRadioSecondLteCell: setRadioSecondLteCellAction,
    setSelectedRadioNodeRow: setSelectedRadioAction,
    setOpenRnDrawer: setOpenRnDrawerAction,
    setCellSaved:setCellSavedAction,
    setSelectedDuNode: setSelectedDuAction,
    setRadioFirstNrCell: setRadioFirstNrCellAction,
    setRadioSecondNrCell: setRadioSecondNrCellAction,
    setOpenDuDrawer: setOpenDuDrawerAction,
    setOpenRnCuDrawer: setOpenRnCUDrawerAction,
    setOpenLteDrawer: setOpenLteDrawerAction,
    setOpenNrDrawer: setOpenNrDrawerAction,
    setOpenCellDrawer: setOpenCellDrawerAction,
    setSiteOfflineDevice: setSiteOfflineAction,
    setSelectedNote: setSelectedNoteAction,
    setLabelList:setLabelListAction,
    setSelectedNotifyLabel:setNotifyLabelAction,
    setSelectedDeviceId:setSelectedDeviceIdAction,
    setSelectedGeoRegions: setSelectedGeoRegionsAction,
  },
});

export const DeviceReducers = helpersSlice.reducer;
export const {
  setSelectedDevice,
  setDeviceDataCount,
  setDrawerCounts,
  setSelectedDeviceAlarms,
  setNoOfSelectedRow,
  setDeviceAction,
  selectedTemplate,
  setSelectedType,
  selectedGlobalTemplate,
  setSelectedDeviceAlarmCount,
  setOpenDeviceDrawer,
  setSelectedRnCellConfig,
  setRadioFirstLteCell,
  setRadioSecondLteCell,
  setSelectedRadioNodeRow,
  setOpenRnDrawer,
  setCellSaved,
  setSelectedDuNode,
  setRadioFirstNrCell,
  setRadioSecondNrCell,
  setOpenDuDrawer,
  setOpenRnCuDrawer,
  setOpenLteDrawer,
  setOpenNrDrawer,
  setOpenCellDrawer,
  setSiteOfflineDevice,
  setSelectedNote,
  setLabelList,
  setSelectedNotifyLabel,
  setSelectedDeviceId,
  setSelectedGeoRegions,
} = helpersSlice.actions;
